


// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import {
//   Box, Typography, IconButton, Dialog, DialogContent, DialogTitle,
//   FormControl, InputLabel, Select, MenuItem,
// } from '@mui/material';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import CloseIcon from '@mui/icons-material/Close';
// import TableComponent from '../../Components/TableComponent/TableComponent';
// import { SnackBarComponent } from '../../Components/snackBar/snackBar';
// import { API_BASE_URL } from '../../config';
// import { LoadingSpinner } from '../../Components/spinner/spinner';
// import { useTranslation } from 'react-i18next';

// export const LegalTeamComponent = () => {
//   const { t } = useTranslation();

//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [categories, setCategories] = useState(['All']);
//   const [categoryFilter, setCategoryFilter] = useState('Legal'); // Default category "Legal"

//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('info');

//   const [openDialog, setOpenDialog] = useState(false);
//   const [selectedImage, setSelectedImage] = useState('');

//   const columns = [
//     { id: 'slNo', field: 'slNo', headerName: t('legalTeam.slNo'), width: 80 },
//     { id: 'name', field: 'name', headerName: t('legalTeam.name'), width: 200 },
//     { id: 'designation', field: 'designation', headerName: t('legalTeam.designation'), width: 200 },
//     { id: 'qualification', field: 'qualification', headerName: t('legalTeam.qualification'), width: 180 },
//     {
//       id: 'photo',
//       field: 'photo',
//       headerName: t('legalTeam.photo'),
//       width: 100,
//       renderCell: (params) =>
//         params.value ? (
//           <IconButton onClick={() => handleOpenImage(params.value)} color="primary">
//             <VisibilityIcon />
//           </IconButton>
//         ) : (
//           'N/A'
//         ),
//     },
//   ];

//   useEffect(() => {
//     fetchCategories();
//   }, []);

//   useEffect(() => {
//     fetchLegalTeam(categoryFilter);
//   }, [categoryFilter]);

//   const fetchCategories = async () => {
//     try {
//       const response = await axios.get(`${API_BASE_URL}/home-notification/legal-team/`);
//       const uniqueCategories = Array.from(
//         new Set(response.data.map((item) => item.catogary).filter((cat) => !!cat))
//       );
//       // Include "All" option at the beginning
//       setCategories([ ...uniqueCategories]);
//     } catch (error) {
//       console.error('Failed to fetch categories:', error);
//       setSnackbarMessage(t('legalTeam.categoryLoadError'));
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//       setCategories(['All']);
//     }
//   };

//   const fetchLegalTeam = (category) => {
//     setLoading(true);
//     let url = `${API_BASE_URL}/home-notification/legal-team/`;
//     if (category && category !== 'All') {
//       url += `?catogary=${encodeURIComponent(category)}`;
//     }
//     axios
//       .get(url)
//       .then((response) => {
//         const data = response.data.map((item, index) => ({
//           id: item.id,
//           slNo: index + 1,
//           name: item.name,
//           designation: item.designation,
//           qualification: item.qualification,
//           roles: item.roles_and_responsibility,
//           appointment_date: item.appointment_date,
//           renewal_date: item.renewal_date,
//           catogary: item.catogary,
//           rank: item.rank,
//           photo: item.photo,
//         }));
//         setRows(data);
//         setLoading(false);
//         setSnackbarMessage(t('legalTeam.dataLoaded'));
//         setSnackbarSeverity('success');
//         setSnackbarOpen(true);
//       })
//       .catch((error) => {
//         console.error('Failed to fetch legal team data:', error);
//         setSnackbarMessage(t('legalTeam.dataLoadError'));
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//         setLoading(false);
//       });
//   };

//   const handleCategoryChange = (event) => {
//     setCategoryFilter(event.target.value);
//   };

//   const handleSnackbarClose = () => {
//     setSnackbarOpen(false);
//   };

//   const handleOpenImage = (imageUrl) => {
//     setSelectedImage(imageUrl);
//     setOpenDialog(true);
//   };

//   const handleCloseDialog = () => {
//     setOpenDialog(false);
//     setSelectedImage('');
//   };

//   if (loading) {
//     return <LoadingSpinner size={30} />;
//   }

//   return (
//     <Box
//       sx={{
//         width: '100%',
//         mt: 8,
//         mb: 1,
//         borderRadius: 2,
//         boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
//         backgroundColor: '#fff',
//       }}
//     >
//       <Box
//         display="flex"
//         justifyContent="space-between"
//         alignItems="center"
//         bgcolor="rgba(195,234,203,0.1)"
//         p={2}
//         mb={2}
//       >
//         <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold' }}>
//           {t('legalTeam.heading')}
//         </Typography>
//         <FormControl sx={{ minWidth: 180 }}>
//           <InputLabel id="category-filter-label">{t('legalTeam.categoryFilter')}</InputLabel>
//           <Select
//             labelId="category-filter-label"
//             value={categoryFilter}
//             label={t('legalTeam.categoryFilter')}
//             onChange={handleCategoryChange}
//             size="small"
//           >
//             {categories.map((cat) => (
//               <MenuItem key={cat} value={cat}>
//                 {cat}
//               </MenuItem>
//             ))}
//           </Select>
//         </FormControl>
//       </Box>

//       <TableComponent
//         columns={columns}
//         rows={rows}
//         manageColumnStatus
//         enableSort
//         sx={{
//           '& .MuiDataGrid-columnHeaders': {
//             backgroundColor: '#1976d2',
//             color: '#fff',
//             fontWeight: 'bold',
//           },
//         }}
//       />

//       <SnackBarComponent
//         open={snackbarOpen}
//         message={snackbarMessage}
//         severity={snackbarSeverity}
//         onClose={handleSnackbarClose}
//       />

//       <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
//         <DialogTitle sx={{ m: 0, p: 2 }}>
//           <IconButton
//             aria-label="close"
//             onClick={handleCloseDialog}
//             sx={{
//               position: 'absolute',
//               right: 8,
//               top: 8,
//               color: (theme) => theme.palette.grey[500],
//             }}
//           >
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>
//         <DialogContent sx={{ textAlign: 'center' }}>
//           {selectedImage ? (
//             <img
//               src={selectedImage}
//               alt={t('legalTeam.altText')}
//               style={{ maxWidth: '100%', maxHeight: '70vh', borderRadius: '8px' }}
//             />
//           ) : (
//             <Typography>{t('legalTeam.noImage')}</Typography>
//           )}
//         </DialogContent>
//       </Dialog>
//     </Box>
//   );
// };


import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Box, Typography, IconButton, Dialog, DialogContent, DialogTitle,
  FormControl, InputLabel, Select, MenuItem,
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';
import TableComponent from '../../Components/TableComponent/TableComponent';
import { SnackBarComponent } from '../../Components/snackBar/snackBar';
import { API_BASE_URL } from '../../config';
import { LoadingSpinner } from '../../Components/spinner/spinner';
import { useTranslation } from 'react-i18next';

export const LegalTeamComponent = () => {
  const { t } = useTranslation();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState(['All']);
  const [categoryFilter, setCategoryFilter] = useState('Legal'); // Default category "Legal"

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');

  const columns = [
    { id: 'slNo', field: 'slNo', headerName: t('legalTeam.slNo'), width: 80 },
    { id: 'name', field: 'name', headerName: t('legalTeam.name'), width: 200 },
    { id: 'designation', field: 'designation', headerName: t('legalTeam.designation'), width: 200 },
    { id: 'qualification', field: 'qualification', headerName: t('legalTeam.qualification'), width: 180 },
    {
      id: 'photo',
      field: 'photo',
      headerName: t('legalTeam.photo'),
      width: 100,
      renderCell: (params) =>
        params.value ? (
          <IconButton onClick={() => handleOpenImage(params.value)} color="primary" size="small">
            <VisibilityIcon fontSize="small" />
          </IconButton>
        ) : (
          'N/A'
        ),
    },
  ];

  useEffect(() => {
    fetchCategories();
  }, []);

  useEffect(() => {
    fetchLegalTeam(categoryFilter);
  }, [categoryFilter]);

  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/home-notification/legal-team/`);
      const uniqueCategories = Array.from(
        new Set(response.data.map((item) => item.catogary).filter((cat) => !!cat))
      );
      // Include "All" option at the beginning
      setCategories([...uniqueCategories]);
    } catch (error) {
      console.error('Failed to fetch categories:', error);
      setSnackbarMessage(t('legalTeam.categoryLoadError'));
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      setCategories(['All']);
    }
  };

  const fetchLegalTeam = (category) => {
    setLoading(true);
    let url = `${API_BASE_URL}/home-notification/legal-team/`;
    if (category && category !== 'All') {
      url += `?catogary=${encodeURIComponent(category)}`;
    }
    axios
      .get(url)
      .then((response) => {
        const data = response.data.map((item, index) => ({
          id: item.id,
          slNo: index + 1,
          name: item.name,
          designation: item.designation,
          qualification: item.qualification,
          roles: item.roles_and_responsibility,
          appointment_date: item.appointment_date,
          renewal_date: item.renewal_date,
          catogary: item.catogary,
          rank: item.rank,
          photo: item.photo,
        }));
        setRows(data);
        setLoading(false);
        setSnackbarMessage(t('legalTeam.dataLoaded'));
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
      })
      .catch((error) => {
        console.error('Failed to fetch legal team data:', error);
        setSnackbarMessage(t('legalTeam.dataLoadError'));
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setLoading(false);
      });
  };

  const handleCategoryChange = (event) => {
    setCategoryFilter(event.target.value);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleOpenImage = (imageUrl) => {
    setSelectedImage(imageUrl);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedImage('');
  };

  if (loading) {
    return <LoadingSpinner size={30} />;
  }

  return (
    <Box
      sx={{
        width: '100%',
        mt: 8,
        mb: 1,
        borderRadius: 2,
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        backgroundColor: '#fff',
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        bgcolor="rgba(195,234,203,0.1)"
        p={2}
        mb={2}
      >
        <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold' }}>
          {t('legalTeam.heading')}
        </Typography>
        <FormControl sx={{ minWidth: 180 }}>
          <InputLabel id="category-filter-label">{t('legalTeam.categoryFilter')}</InputLabel>
          <Select
            labelId="category-filter-label"
            value={categoryFilter}
            label={t('legalTeam.categoryFilter')}
            onChange={handleCategoryChange}
            size="small"
          >
            {categories.map((cat) => (
              <MenuItem key={cat} value={cat}>
                {cat}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <TableComponent
        columns={columns}
        rows={rows}
        manageColumnStatus
        enableSort
        sx={{
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#1976d2',
            color: '#fff',
            fontWeight: 'bold',
          },
        }}
      />

      <SnackBarComponent
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />

      {/* Smaller Photo Dialog with Circular Image */}
      <Dialog 
        open={openDialog} 
        onClose={handleCloseDialog} 
        maxWidth="xs" 
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '16px',
            overflow: 'hidden',
            maxWidth: '320px', // Smaller width
            margin: '16px',
            width: '100%',
          }
        }}
      >
        <DialogTitle 
          sx={{ 
            m: 0, 
            p: 1,
            backgroundColor: '#f5f5f5',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            minHeight: '48px'
          }}
        >
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            size="small"
            sx={{
              color: (theme) => theme.palette.grey[500],
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
              },
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <DialogContent 
          sx={{ 
            textAlign: 'center', 
            p: 2,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '180px',
            pt: 3,
            pb: 3
          }}
        >
          {selectedImage ? (
            <Box
              sx={{
                width: '220px',
                height: '220px',
                borderRadius: '50%', // Makes it perfectly circular
                overflow: 'hidden',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                backgroundColor: '#f0f0f0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '4px solid #fff',
                outline: '1px solid #e0e0e0'
              }}
            >
              <img
                src={selectedImage}
                alt={t('legalTeam.altText')}
                style={{ 
                  width: '100%', 
                  height: '100%', 
                  objectFit: 'cover',
                  display: 'block'
                }}
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentNode.innerHTML = 
                    `<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                       <Typography variant="body2" color="textSecondary">${t('legalTeam.noImage')}</Typography>
                     </Box>`;
                }}
              />
            </Box>
          ) : (
            <Box
              sx={{
                width: '220px',
                height: '220px',
                borderRadius: '50%',
                overflow: 'hidden',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                backgroundColor: '#f0f0f0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '4px solid #fff',
                outline: '1px solid #e0e0e0'
              }}
            >
              <Typography variant="body2" color="textSecondary">
                {t('legalTeam.noImage')}
              </Typography>
            </Box>
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
};